export const BUSINESS = {
  name: "KS Granite House LLC",
  phone: "913-203-0750",
  phoneHref: "tel:+19132030750",
  email: "ksgranitehouse@gmail.com",
  address: "956 Scott Ave, Kansas City, KS 66105",
  mapHref: "https://maps.google.com/?q=956+Scott+Ave,+Kansas+City,+KS+66105",
  facebook: "https://www.facebook.com/profile.php?id=100087785286771",
  instagram: "https://www.instagram.com/ksgranitehousellc/",
};

export const NAV = [
  { label: "Home", href: "#top" },
  { label: "Countertops", href: "#countertops" },
  { label: "Restoration", href: "#restoration" },
  { label: "Our Work", href: "#work" },
  { label: "Remnants", href: "#remnants" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#estimate" },
];

export const IMG = {
  kitchen: "/img/e44ef294.jpg",
  vanity: "/img/d49de518.jpg",
  bar: "/img/b5f19bdc.jpg",
  fireplace: "/img/47b4a3ea.jpg",
  signage: "/img/1b69ae3c.jpg",
  darkStone: "/img/575f885a.jpg",
  whiteMarble: "/img/7fe487f8.jpg",
  mark: "/img/logo-mark.png",
  logoFull: "/img/logo-full.jpg",
};

export const MATERIALS = [
  {
    id: "granite",
    name: "Granite",
    tag: "Natural · Heat-tolerant",
    img: IMG.darkStone,
    summary: "Quarried natural stone with depth, movement and character no two slabs share.",
    detail:
      "Granite is a classic for busy kitchens. It stands up well to heat and everyday wear, and every slab carries its own pattern, so choosing your exact slab matters. Periodic sealing keeps it looking its best.",
    traits: [["Heat", "Excellent"], ["Scratch", "Excellent"], ["Care", "Seal periodically"]],
    bestFor: "Kitchens, islands, outdoor bars, high-traffic surfaces",
  },
  {
    id: "quartz",
    name: "Quartz",
    tag: "Engineered · Low-maintenance",
    img: IMG.vanity,
    summary: "Engineered surfaces with consistent color, clean veining and no sealing required.",
    detail:
      "Quartz is non-porous and consistent from slab to slab, which makes it easy to plan large or multi-room projects. Use trivets for hot pans. Ideal when you want a clean, uniform look with minimal upkeep.",
    traits: [["Heat", "Use trivets"], ["Stain", "Excellent"], ["Care", "No sealing"]],
    bestFor: "Kitchens, vanities, family homes, multi-unit builds",
  },
  {
    id: "quartzite",
    name: "Quartzite",
    tag: "Natural · Ultra-hard",
    img: IMG.bar,
    summary: "The look of marble with the toughness of natural quartz crystal.",
    detail:
      "Quartzite is a natural stone formed under heat and pressure. It offers soft, marble-like veining with strong durability. It is a premium choice for statement islands and bars.",
    traits: [["Heat", "Excellent"], ["Scratch", "Excellent"], ["Care", "Seal periodically"]],
    bestFor: "Statement islands, bars, luxury kitchens",
  },
  {
    id: "marble",
    name: "Marble",
    tag: "Natural · Timeless",
    img: IMG.whiteMarble,
    summary: "Soft, luminous veining for vanities, fireplaces and refined spaces.",
    detail:
      "Marble brings an elegance nothing else matches. It is softer and more porous than granite or quartzite, so it shines in bathrooms, fireplace surrounds and spaces where a lived-in patina is welcome.",
    traits: [["Heat", "Good"], ["Etching", "Can etch"], ["Care", "Seal regularly"]],
    bestFor: "Vanities, fireplace surrounds, accent walls",
  },
];

export const GALLERY = [
  { src: IMG.kitchen, title: "Kitchen island & perimeter", type: "Kitchen", w: 1500, h: 2000 },
  { src: IMG.bar, title: "Basement bar & island", type: "Bar", w: 1500, h: 2000 },
  { src: IMG.vanity, title: "Double bathroom vanity", type: "Vanity", w: 1575, h: 2000 },
  { src: IMG.fireplace, title: "Floor-to-ceiling fireplace surround", type: "Fireplace", w: 1500, h: 2000 },
  { src: IMG.signage, title: "Chef's kitchen with marble-look tops", type: "Kitchen", w: 400, h: 299 },
];

export const SERVICES = [
  { n: "01", title: "Kitchen Countertops & Islands", text: "Perimeter tops, waterfall and statement islands, pantries and full-height backsplashes.", img: IMG.kitchen },
  { n: "02", title: "Bathroom Vanities", text: "Single and double vanities with clean undermount sink cutouts and polished edges.", img: IMG.vanity },
  { n: "03", title: "Bars & Entertaining", text: "Wet bars, basement bars and serving counters built to be the center of the room.", img: IMG.bar },
  { n: "04", title: "Fireplace Surrounds", text: "Stone surrounds, hearths and slab walls that turn a fireplace into a feature.", img: IMG.fireplace },
  { n: "05", title: "Countertop Restoration", text: "Bring tired, dull or damaged stone back to life without replacing it.", img: IMG.darkStone },
  { n: "06", title: "Residential & Commercial", text: "From a single vanity to multi-room builds for homes and businesses.", img: IMG.whiteMarble },
];

export const PROCESS = [
  { n: "01", title: "Consult & Select", text: "Share your plans or photos. We walk you through granite, quartz, quartzite and marble options and help you choose your slab." },
  { n: "02", title: "Laser Templating", text: "We digitally laser-template your cabinets on site for precise measurements, tight seams and a true fit." },
  { n: "03", title: "In-House Fabrication", text: "Your slab is cut, edged and finished in our own Kansas City shop, so quality and scheduling stay in our hands." },
  { n: "04", title: "Professional Installation", text: "Our crew installs, levels, seals and cleans up. Typical installation is 5–10 business days after deposit." },
];

export const REVIEWS = [
  { quote: "Had a great experience with KS Granite House! Everyone was super friendly and helpful from start to finish. They helped us pick out the perfect countertops for our kitchen, and the installation turned out amazing. The whole process was smooth, and the pricing was very reasonable. Definitely recommend them!", name: "Brayden Prebble", place: "Kansas City, KS", project: "Kitchen countertops" },
  { quote: "We couldn't be happier with our new countertops! KS Granite House did an awesome job. The measurements were spot on, the edges look beautiful, and you can tell they really care about the quality of their work. Everything came out exactly how we wanted. We'll definitely be using them again for our bathrooms!", name: "Andres Blancarte", place: "Kansas City, MO", project: "Countertops" },
  { quote: "Great company to work with! Fair prices, good communication, and beautiful work. They showed up when they said they would and did a fantastic job installing our granite countertops. Really happy with how everything turned out. Highly recommend KS Granite House!", name: "Jude Landes", place: "Kansas City, KS", project: "Granite countertops" },
];

export const PROJECT_TYPES = ["Kitchen countertops", "Bathroom vanity", "Kitchen + bathroom", "Island / bar", "Fireplace surround", "Countertop restoration", "Other"];
export const CUSTOMER_TYPES = ["Homeowner", "Contractor", "Remodeler", "Builder", "Designer"];
export const MATERIAL_OPTIONS = ["Granite", "Quartz", "Quartzite", "Marble", "Not sure yet"];
export const SQFT_OPTIONS = ["10–20 sq ft", "21–30 sq ft", "31–40 sq ft", "41–50 sq ft", "51+ sq ft", "Not sure"];
export const TIMELINE_OPTIONS = ["As soon as possible", "Within 1 month", "1–3 months", "Just planning"];
